import {
    colors,
    createTheme,
    responsiveFontSizes
} from '@mui/material';

import {softShadows} from './shadows';
import typography from "./typography";

export const baseTheme = responsiveFontSizes(createTheme({
    direction: 'ltr',
    typography,
    overrides: {
        MuiLinearProgress: {
            root: {
                borderRadius: 3,
                overflow: 'hidden'
            }
        },
        MuiListItemIcon: {
            root: {
                minWidth: 32
            }
        },
        MuiChip: {
            root: {
                backgroundColor: 'rgba(0,0,0,0)'
            }
        },
        MuiInputBase: {
            input: {
                '&::placeholder': {
                    opacity: 1,
                    color: colors.blueGrey[600]
                }
            }
        },
    },
    palette: {
        type: 'base',
        action: {
            active: '#0077D3',
        },
        primary: {
            main: '#0077D3',
            dark: '#0b3599',
        },
        secondary: {
            light: colors.yellow[600],
            main: '#fcb402',
            dark: colors.yellow[900],
        },
        info: {
            main: '#0077D3',
            dark: '#0b3599',
        },
        text: {
            primary: '#0077D3',
            secondary: '#0b3599'
        }
    },
    shadows: softShadows
}));
